import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import CalidadMercaderiaEmbarcadaView from '../../components/calidad/CalidadMercaderiaEmbarcadaView'
import CalidadMercaderiaEmbarcadaTotalView from '../../components/calidad/CalidadMercaderiaEmbarcadaTotalView'
import { actualizarDatosMercaderiaEmbarcada, actualizarTotalMercaderiaEmbarcada } from '../../actions/calidad'
import { FORM_MERCADERIA_EMBARCADA } from '../../../../config/forms'
import { parseEntityId } from '../../../../models/entity'
import CamposBusqueda from '../../components/listados/CamposBusqueda'

function CalidadMercaderiaEmbarcada (props) {
  const { actualizarDatosMercaderiaEmbarcada, actualizarTotalMercaderiaEmbarcada, change: formChange } = props

  useEffect(() => {
    actualizarDatosMercaderiaEmbarcada(new Date(), new Date())
    actualizarTotalMercaderiaEmbarcada(new Date(), new Date())
  }, [actualizarDatosMercaderiaEmbarcada, actualizarTotalMercaderiaEmbarcada])

  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaDesde', fechaD)
    formChange('fechaHasta', fechaH)
  }

  const handleSubmit = () => {
    const { fechaDesde, fechaHasta, exportadorMercaderia, cerealMercaderia } = props
    const exportador = parseEntityId(exportadorMercaderia) || null
    const cereal = (cerealMercaderia && (cerealMercaderia.trim() !== 'UNDEF') && cerealMercaderia.trim()) || null
    actualizarDatosMercaderiaEmbarcada(fechaDesde, fechaHasta, exportador, cereal)
    actualizarTotalMercaderiaEmbarcada(fechaDesde, fechaHasta, exportador, cereal)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <CamposBusqueda actualizarFechas={actualizarFechas} handleSubmit={handleSubmit} />
      <CalidadMercaderiaEmbarcadaTotalView />
      <CalidadMercaderiaEmbarcadaView />
    </>
  )
}

const selector = formValueSelector(FORM_MERCADERIA_EMBARCADA)

const mapStateToProps = (state) => ({
  exportadorMercaderia: selector(state, 'exportador'),
  cerealMercaderia: selector(state, 'cereal'),
  fechaDesde: selector(state, 'fechaDesde'),
  fechaHasta: selector(state, 'fechaHasta')
})

const mapActionsToProps = {
  actualizarDatosMercaderiaEmbarcada,
  actualizarTotalMercaderiaEmbarcada
}

const withReduxForm = reduxForm({
  form: FORM_MERCADERIA_EMBARCADA
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(CalidadMercaderiaEmbarcada))
